import cn from "@/v2-ui/utils/utils.cn"
import { useTableContext } from "./table.context"
import { SELECTION_COLUMN_ID, SPACER_COLUMN_ID } from "./table.constants"
import { getColumnSizeStyle } from "./table.utils"

export type TableSkeletonRowsProps = {
  rowCount: number
}

/**
 * Placeholder rows shaped like the table's own: one shimmering bar per
 * visible column, at the column's width, so the rows that load in land
 * where their placeholders stood. Rendered inside a `<tbody>` — the initial
 * skeleton fills one with them, the body appends a few below its last row
 * while the next page is on its way.
 */
function TableSkeletonRows(props: TableSkeletonRowsProps) {
  const { rowCount } = props
  const { table, hasPersistence } = useTableContext()
  const columnSizing = table.getState().columnSizing
  const visibleColumns = table.getVisibleLeafColumns()

  return Array.from({ length: rowCount }, (_, rowIndex) => (
    <tr
      key={rowIndex}
      className="ui-table-body-row ui-table-body-row-is-skeleton"
      aria-hidden
    >
      {visibleColumns.map((column) => {
        if (column.id === SPACER_COLUMN_ID) {
          return <td key={column.id} className="ui-table-spacer-cell" />
        }
        return (
          <td
            key={column.id}
            className="ui-table-body-cell"
            style={getColumnSizeStyle({ column, columnSizing, hasPersistence })}
          >
            <div
              className={cn("ui-table-skeleton-bar", {
                "ui-table-skeleton-bar-is-checkbox":
                  column.id === SELECTION_COLUMN_ID,
              })}
            />
          </td>
        )
      })}
    </tr>
  ))
}

export default TableSkeletonRows
